import { render, staticRenderFns } from "./DashboardBocapio.vue?vue&type=template&id=331c481d"
import script from "./DashboardBocapio.vue?vue&type=script&lang=js"
export * from "./DashboardBocapio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports